import { useState } from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { BuildingFillGear } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
import KButton from '../components/KButton'
import KConfirm from '../components/KConfirm'
import KLayerNavigation from '../components/KLayerNavigation'
import { hideKAlert, isUserLoggedIn } from '../helpers'
import { t } from '../locale'

function Delete() {
  const navigate = useNavigate()

  const [confirmShow, setConfirmShow] = useState(false)

  function deleteCompany() {
    setConfirmShow(false)

    fetch(`${process.env.REACT_APP_API_URL}/company-admin`, {
      method: 'DELETE',
    })
      .then(r => r.json())
      .then(r => {
        if (r.ok) {
          navigate('/user/logout')
        }
      })
  }

  return (
    <>
      <Container>
        <Row>
          <div className='sidebar col-md-3 col-lg-2 p-0'>
            <KLayerNavigation logged={isUserLoggedIn()} />
          </div>
          <main className='col-md-9 col-lg-10 ps-2 ps-md-3 px-md-4'>
            <Card>
              <Card.Header>
                <BuildingFillGear />
                <span className='p-1 align-middle'>{t('companyDelete')}</span>
              </Card.Header>

              <Card.Body>{t('textCompanyDelete')}</Card.Body>
            </Card>

            <Row className='mt-3'>
              <Col>
                <KButton
                  id='btn-cancel'
                  icon='stars'
                  variant='success text-white'
                  label={t('cancel')}
                  onClick={() => {
                    hideKAlert()
                    navigate('/company')
                  }}
                />
                &nbsp;
                {/* <KButton id='btn-download'
                                    icon='cloud-download'
                                    variant='info'
                                    label={t('companyDataDownload')}
                                    onClick={downloadData} /> */}
              </Col>
              <Col className='text-end'>
                <KButton
                  id='btn-delete'
                  icon='trash'
                  label={t('delete')}
                  variant='danger'
                  onClick={() => setConfirmShow(true)}
                />
              </Col>
            </Row>
          </main>
        </Row>
      </Container>

      <KConfirm
        show={confirmShow}
        message={t('deleteClient')}
        onConfirm={() => deleteCompany()}
        onCancel={() => setConfirmShow(false)}
      />
    </>
  )
}

export default Delete
